import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './auth/auth.guard';
import { b2bEnabledGuard } from './auth/b2b-enabled.guard';
import { RolesAccessComponent } from './features/roles-access/roles-access.component';
import { UnauthorizedComponent } from './features/unauthorized/unauthorized.component';
import { SidemenuComponent } from './features/sidemenu/sidemenu.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { ComponentsComponent } from './features/components/components.component';
import { ProductsComponent } from './features/products/products.component';
import { HsnExceptionsComponent } from './features/hsn/hsn-exceptions/hsn-exceptions.component';
import { OffersComponent } from './features/offers/offers.component';
import { ReturnPolicyComponent } from './features/return-policy/return-policy.component';
import { ReturnsComponent } from './features/returns/returns.component';
import { AddProductComponent } from './features/products/add-product/add-product.component';
import { BulkAddProductsComponent } from './features/products/bulk-add-products/bulk-add-products.component';
import { BulkEanMappingComponent } from './features/products/bulk-ean-mapping/bulk-ean-mapping.component';
import { AdminDashboardComponent } from './features/dashboard/admin-dashboard/admin-dashboard.component';
import { StoreDashboardComponent } from './features/dashboard/store-dashboard/store-dashboard.component';
import { AddInventoryComponent } from './features/inventory/add-inventory/add-inventory.component';
import { InventoryListComponent } from './features/inventory/inventory-list/inventory-list.component';
import { TransferInventoryComponent } from './features/inventory/transfer-inventory/transfer-inventory.component';
import { LowStockProductsComponent } from './features/reorders/low-stock-products/low-stock-products.component';
import { ReorderRequestsComponent } from './features/reorders/reorder-requests/reorder-requests.component';
import { AddVendorComponent } from './features/vendors/add-vendor/add-vendor.component';
import { VendorsComponent } from './features/vendors/vendors/vendors.component';
import { AddManufacturersComponent } from './features/manufacturers/add-manufacturers/add-manufacturers.component';
import { ManufacturersComponent } from './features/manufacturers/manufacturer-component';
import { ProductVendorMappingComponent } from './features/product-vendor-mapping/product-vendor-mapping.component';
import { VendorSkuUploadComponent } from './features/vendors/vendor-sku-upload/vendor-sku-upload.component';
import { PoComponent } from './features/po/po.component';
import { CreatePoComponent } from './features/po/create-po/create-po.component';
import { GrnComponent } from './features/grn/grn.component';
import { CreateGrnComponent } from './features/grn/create-grn/create-grn.component';
import { TransferOutListComponent } from './features/transfer-out-list/transfer-out-list.component';
import { CreateTransferOutComponent } from './features/transfer-out-list/create-transfer-out/create-transfer-out.component';
import { TransferInListComponent } from './features/transfer-in-list/transfer-in-list.component';
import { CreateTransferInComponent } from './features/transfer-in-list/create-transfer-in/create-transfer-in.component';
import { PrnComponent } from './features/prn-module/prn-module.component';
import { CreatePrnComponent } from './features/prn-module/create-prn/create-prn.component';
import { BillingListComponent } from './features/billing/billing-list/billing-list.component';
import { OffersModalComponent } from './features/offers/offers-modal/offers-modal.component';
import { AddRepackEntryComponent } from './features/Repack/add-repack/add-repack.component';
import { RepackComponent } from './features/Repack/repack.component';
import { MbqComponent } from './features/mbq/mbq.component';
import { CreateMbqComponent } from './features/mbq/create-mbq/create-mbq.component';
import { PendingChangesGuard } from '../Guard/pending-changes.guard';
import { IndentListComponent } from './features/indent-list/indent-list.component';
import { ViewIndentListComponent } from './features/indent-list/view-indent-list/view-indent-list.component';
import { BillingDetailsComponent } from './features/billing/billing-details/billing-details.component';
import { CreateIndentComponent } from './features/indent-list/create-indent/create-indent.component';
import { PickListComponent } from './features/pick-list/pick-list-view/pick-list.component';
import { PicklistMasterComponent } from './features/pick-list/picklist-master.component';
import { StocktakeComponent } from './features/stocktake/stocktake.component';
import { GstSlabViewComponent } from './features/gstslabs/gstslabs.component';
import { GstSlabCreateComponent } from './features/gstslabs/create-gstslab/create-gstslab.component';
import { ServiceListComponent } from './features/service/service-list.component';
import { CreateServiceComponent } from './features/service/create-service/service-form.component.ts';
import { ServiceBillingComponent } from './features/service-billing/service-billing.component';
import { ClinicOnlyGuard } from '../Guard/ClinicOnlyGuard';
import { StockMovementComponent } from './features/stock-movement/stock-movement.component';
import { StockTakeListComponent } from './features/stocktake/stock-take.component';
import { StockTakeCreateComponent } from './features/stocktake/create-stock-take/create-stock.take.component';
import { StockTakeDetailsComponent } from './features/stocktake/stock-take-details/stock-take-details.component';
import { ReportsComponent } from './features/Reports/reports-list.component';
import { MbqDraftListComponent } from './features/mbq/mbq-draft-list/mbq-draft-list.component';
import { UploadMbqComponent } from './features/mbq/upload-mbq/upload-mbq.component';
import { CreateStockWriteOffComponent } from './features/stock-writeoff/create-stock-writeoff/create-stock-write-off';
import { StockWriteOffListComponent } from './features/stock-writeoff/stock-write-off';
import { UsersComponent } from './features/users/users.component';
import { MyAccountComponent } from './features/my-account/my-account.component';
import { UsersCreateEditComponent } from './features/users/create-users/users-create-edit.component';
import { LocationsComponent } from './features/locations/locations.component';
import { LocationFormComponent } from './features/locations/location-form/location-form.component';
import { ServiceBillingDetailsComponent } from './features/billing/service-billing-details/service-billing-details.component';
import { DetailedReportComponent } from './features/Reports/detailed-report/detailed-report.component';
import { ToolaSyncPageComponent } from './features/toola-sync/toola-sync-page.component';
import { TerminalsComponent } from './features/terminals/terminals.component';
import { SelectStoreComponent } from './features/select-store/select-store.component';
import {
  FORM_RELOAD_PATH,
  FormReloadBlankComponent,
} from './core/services/form-reload.service';
export const routes: Routes = [
  {
    path: 'select-store',
    component: SelectStoreComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'side-menu',
    component: SidemenuComponent,
    canActivate: [AuthGuard],
  },
  {
    // Operations overview: deliberately no `data.roles` (an empty list would
    // lock out every non-super-user). Each tile hides itself when the user
    // cannot read the module behind it.
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'product-list',
    component: ProductsComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        'Admin',
        'WAREHOUSE_MANAGER',
        'CATEGORY_MANAGER',
        'GRN_TEAM',
        'STORE_MANAGER',
        'AREA_MANAGER',
        'ASM',
        'LP_TEAM',
        'MIS_TEAM',
        'GRN_TEAM',
        'LP_TEAM',
        'STORE_MANAGER',
      ],
    },
  },
  {
    path: 'hsn-exceptions',
    component: HsnExceptionsComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['Admin', 'WAREHOUSE_MANAGER', 'CATEGORY_MANAGER', 'MIS_TEAM'],
    },
  },
  {
    path: 'add-product',
    component: AddProductComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      roles: [
        'Admin',
        'WAREHOUSE_MANAGER',
        'CATEGORY_MANAGER',
        'STORE_MANAGER',
        'AREA_MANAGER',
        'ASM',
        'LP_TEAM',
      ],
    },
  },
  {
    // Many SKUs keyed in at once on a spreadsheet-like grid. Roles mirror the
    // backend create API (POST /products), not the wider add-product list —
    // store roles cannot create products there either.
    path: 'bulk-add-products',
    component: BulkAddProductsComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      roles: ['Admin', 'WAREHOUSE_MANAGER', 'CATEGORY_MANAGER', 'MIS_TEAM'],
    },
  },
  {
    // Tag / replace barcodes on many SKUs at once — identity only, no
    // pricing. Same audience as the bulk-add grid (master-data maintainers).
    path: 'bulk-ean-mapping',
    component: BulkEanMappingComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      roles: ['Admin', 'WAREHOUSE_MANAGER', 'CATEGORY_MANAGER', 'MIS_TEAM'],
    },
  },
  {
    path: 'product-vendor-mapping',
    component: ProductVendorMappingComponent,
    canActivate: [AuthGuard],
    data: { roles: [] },
  },
  {
    path: 'vendor-sku-upload',
    component: VendorSkuUploadComponent,
    canActivate: [AuthGuard],
    data: { roles: [] },
  },
  {
    // Self-service account page. Deliberately has NO `data.roles`: the
    // AuthGuard treats an empty roles array as "no role matches" and would
    // send every non-super-user to /unauthorized. Omitting it skips the
    // legacy role check, and the route is not in the RAC page registry, so
    // any signed-in user can reach their own account.
    path: 'my-account',
    component: MyAccountComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'add-vendor',
    component: AddVendorComponent,
    canDeactivate: [PendingChangesGuard],
    canActivate: [AuthGuard],
    data: { roles: [] },
  },
  {
    path: 'po',
    component: PoComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        'Admin',
        'STORE_MANAGER',
        'CATEGORY_MANAGER',
        'MIS_TEAM',
        'ASM',
        'Asm',
        'AREA_MANAGER',
        'Area Manager',
      ],
    },
  },
  {
    path: 'po/create-po',
    component: CreatePoComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['STORE_MANAGER', 'CATEGORY_MANAGER', 'MIS_TEAM'] },
  },
  {
    path: 'po/edit-po/:id',
    component: CreatePoComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['STORE_MANAGER', 'CATEGORY_MANAGER'] },
  },
  {
    path: 'vendors',
    component: VendorsComponent,
    canActivate: [AuthGuard],
    data: { roles: ['Admin', 'CATEGORY_MANAGER', 'MIS_TEAM'] },
  },
  {
    path: 'users',
    component: UsersComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin'] },
  },
  {
    path: 'users/create',
    component: UsersCreateEditComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin'] },
  },
  {
    path: 'users/edit/:id',
    component: UsersCreateEditComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin'] },
  },
  {
    path: 'locations',
    component: LocationsComponent,
    canActivate: [AuthGuard],
    data: { roles: ['Admin'] },
  },
  {
    path: 'locations/create',
    component: LocationFormComponent,
    canActivate: [AuthGuard],
    data: { roles: ['Admin'] },
  },
  {
    path: 'locations/edit/:id',
    component: LocationFormComponent,
    canActivate: [AuthGuard],
    data: { roles: ['Admin'] },
  },
  {
    path: 'manufacturers',
    component: ManufacturersComponent,
    canActivate: [AuthGuard],
    data: { roles: ['CATEGORY_MANAGER'] },
  },
  {
    path: 'add-manufacturers',
    component: AddManufacturersComponent,
    canActivate: [AuthGuard],
    data: { roles: ['CATEGORY_MANAGER'] },
  },
  {
    path: 'edit-manufacturer/:id',
    component: AddManufacturersComponent,
    canActivate: [AuthGuard],
    data: { roles: ['CATEGORY_MANAGER'] },
  },
  {
    path: 'edit-vendor/:id',
    component: AddVendorComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['CATEGORY_MANAGER'] },
  },
  {
    path: 'edit-product/:id',
    component: AddProductComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: [] },
  },
  {
    path: 'offers-list',
    component: OffersComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        'Admin',
        'STORE_MANAGER',
        'WAREHOUSE_MANAGER',
        'MIS_TEAM',
        'GRN_TEAM',
        'CATEGORY_MANAGER',
      ],
    },
  },
  {
    path: 'create-offer',
    component: OffersModalComponent,
    canActivate: [AuthGuard],
    data: { roles: [] },
  },
  {
    // Lane B — return-policy admin editor.
    path: 'return-policy',
    component: ReturnPolicyComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['Admin', 'STORE_MANAGER', 'MIS_TEAM'],
    },
  },
  {
    // Lane D — returns inbox + history.
    path: 'returns',
    component: ReturnsComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['Admin', 'STORE_MANAGER', 'SHIFT_SUPERVISOR', 'MANAGER', 'MIS_TEAM', 'CASHIER'],
    },
  },
  {
    path: 'components',
    component: ComponentsComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'inventory/add',
    component: AddInventoryComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        'WarehouseManager',
        'Admin',
        'MIS_TEAM',
        'CATEGORY_MANAGER',
        'WAREHOUSE_MANAGER',
        'PRN_TEAM',
        'LP_TEAM',
        'INWARD_TEAM',
        'AREA_MANAGER',
        'STORE_MANAGER',
        'ASM',
      ],
    },
  },
  {
    path: 'inventory/transfer',
    component: TransferInventoryComponent,
    canActivate: [AuthGuard],
    data: { roles: ['WarehouseManager'] },
  },
  {
    path: 'inventory/list',
    component: InventoryListComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        'Admin',
        'WAREHOUSE_MANAGER',
        'STORE_MANAGER',
        'CATEGORY_MANAGER',
        'MIS_TEAM',
        'ASM',
        'Asm',
        'AREA_MANAGER',
        'Area Manager',
        'INWARD_TEAM',
        'Inward Team',
        'INWARD TEAM',
        'OUTWARD_TEAM',
        'Outward Team',
        'OUTWARD TEAM',
        'LP_TEAM',
        'Lp Team',
        'LP TEAM',
        'PRN_TEAM',
        'Prn Team',
        'PRN TEAM',
      ],
    },
  },
  {
    path: 'reorders/low-stock',
    component: LowStockProductsComponent,
    canActivate: [AuthGuard],
    data: { roles: ['StoreManager'] },
  },
  {
    path: 'reorders/requests',
    component: ReorderRequestsComponent,
    canActivate: [AuthGuard],
    data: { roles: ['StoreManager'] },
  },
  {
    path: 'dashboard/admin',
    component: AdminDashboardComponent,
    canActivate: [AuthGuard],
    data: { roles: [] },
  },
  {
    path: 'dashboard/store',
    component: StoreDashboardComponent,
    canActivate: [AuthGuard],
    data: { roles: ['StoreManager'] },
  },
  {
    path: 'billing',
    canActivate: [AuthGuard],

    loadChildren: () =>
      import('./features/billing/billing.routes').then((m) => m.BILLING_ROUTES),
    data: {
      roles: ['CASHIER', 'STORE_MANAGER', 'Admin', 'AREA_MANAGER', 'ASM'],
    },
  },
  {
    path: 'billinglist',
    component: BillingListComponent,
    canActivate: [AuthGuard],
    data: { roles: ['Cashier', 'Admin', 'STORE_MANAGER'] },
  },
  {
    path: 'billinglist/:id',
    component: BillingDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: ['Cashier', 'Admin', 'STORE_MANAGER'] },
  },
  {
    path: 'toola-sync',
    component: ToolaSyncPageComponent,
    canActivate: [AuthGuard],
    data: { roles: ['Admin', 'STORE_MANAGER'] },
  },
  {
    path: 'service-billing-details/:id',
    component: ServiceBillingDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: ['Cashier', 'Admin', 'STORE_MANAGER'] },
  },
  {
    path: 'grn',
    component: GrnComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        'Admin',
        'STORE_MANAGER',
        'CATEGORY_MANAGER',
        'MIS_TEAM',
        'GRN_TEAM',
        'ASM',
        'Asm',
        'AREA_MANAGER',
        'Area Manager',
      ],
    },
  },
  {
    path: 'grn/create-grn',
    component: CreateGrnComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      roles: [
        'Admin',
        'STORE_MANAGER',
        'CATEGORY_MANAGER',
        'MIS_TEAM',
        'GRN_TEAM',
        'ASM',
        'Asm',
        'AREA_MANAGER',
        'Area Manager',
      ],
    },
  },
  {
    path: 'grn/edit/:id',
    component: CreateGrnComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      roles: [
        'STORE_MANAGER',
        'CATEGORY_MANAGER',
        'Admin',
        'MIS_TEAM',
        'GRN_TEAM',
        'ASM',
        'Asm',
        'AREA_MANAGER',
        'Area Manager',
      ],
    },
  },
  {
    path: 'transfer-out',
    component: TransferOutListComponent,
    canActivate: [AuthGuard],

    data: {
      roles: [
        'Admin',
        'STORE_MANAGER',
        'WAREHOUSE_MANAGER',
        'MIS_TEAM',
        'INWARD_TEAM',
        'Inward Team',
        'INWARD TEAM',
        'ASM',
        'Asm',
        'AREA_MANAGER',
        'Area Manager',
      ],
    },
  },
  {
    path: 'transfer-out/create',
    component: CreateTransferOutComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      roles: [
        'STORE_MANAGER',
        'WAREHOUSE_MANAGER',
        'Admin',
        'MIS_TEAM',
        'GRN_TEAM',
        'INWARD_TEAM',
        'ASM',
        'Asm',
        'AREA_MANAGER',
        'Area Manager',
      ],
    },
  },
  {
    path: 'transfer-out/edit/:id',
    component: CreateTransferOutComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      roles: [
        'STORE_MANAGER',
        'WAREHOUSE_MANAGER',
        'Admin',
        'MIS_TEAM',
        'GRN_TEAM',
        'INWARD_TEAM',
        'Inward Team',
        'INWARD TEAM',
        'ASM',
        'Asm',
        'AREA_MANAGER',
        'Area Manager',
      ],
    },
  },
  {
    path: 'transfer-out/eway-bill/create',
    loadComponent: () =>
      import('./features/transfer-out-list/eway-bill-creation/eway-bill-creation.component').then(
        (m) => m.EwayBillCreationComponent,
      ),
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      roles: [
        'STORE_MANAGER',
        'WAREHOUSE_MANAGER',
        'Admin',
        'MIS_TEAM',
        'GRN_TEAM',
        'INWARD_TEAM',
        'ASM',
        'Asm',
        'AREA_MANAGER',
        'Area Manager',
      ],
    },
  },
  {
    path: 'transfer-box/print',
    loadComponent: () =>
      import('./features/transfer-box/box-print/box-print.component').then(
        (m) => m.BoxPrintComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      roles: [
        'Admin',
        'STORE_MANAGER',
        'WAREHOUSE_MANAGER',
        'MIS_TEAM',
        'INWARD_TEAM',
        'ASM',
        'AREA_MANAGER',
        // Label-station role: print-only (mirrors backend BOX_PRINT_ROLES).
        'BOX_PRINTER',
      ],
    },
  },
  {
    path: 'transfer-box/trips',
    loadComponent: () =>
      import('./features/transfer-box/trip-list/trip-list.component').then(
        (m) => m.TripListComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      roles: [
        'Admin',
        'STORE_MANAGER',
        'WAREHOUSE_MANAGER',
        'MIS_TEAM',
        'INWARD_TEAM',
        'ASM',
        'AREA_MANAGER',
      ],
    },
  },
  {
    path: 'transfer-box/dispatch-sheet',
    loadComponent: () =>
      import('./features/transfer-box/dispatch-sheet/dispatch-sheet.component').then(
        (m) => m.DispatchSheetComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      roles: [
        'Admin',
        'STORE_MANAGER',
        'WAREHOUSE_MANAGER',
        'MIS_TEAM',
        'INWARD_TEAM',
        'ASM',
        'AREA_MANAGER',
      ],
    },
  },
  {
    path: 'transfer-box/dispatch-sheet/:tripId',
    loadComponent: () =>
      import('./features/transfer-box/dispatch-sheet/dispatch-sheet.component').then(
        (m) => m.DispatchSheetComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      roles: [
        'Admin',
        'STORE_MANAGER',
        'WAREHOUSE_MANAGER',
        'MIS_TEAM',
        'INWARD_TEAM',
        'ASM',
        'AREA_MANAGER',
      ],
    },
  },
  {
    path: 'transfer-in',
    component: TransferInListComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        'Admin',
        'STORE_MANAGER',
        'WAREHOUSE_MANAGER',
        'MIS_TEAM',
        'INWARD_TEAM',
        'INWARD_TEAM',
        'INWARD TEAM',
        'ASM',
        'Asm',
        'AREA_MANAGER',
        'Area Manager',
      ],
    },
  },
  {
    path: 'transfer-in/create/:id',
    component: CreateTransferInComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        'STORE_MANAGER',
        'WAREHOUSE_MANAGER',
        'Admin',
        'MIS_TEAM',
        'INWARD_TEAM',
        'INWARD_TEAM',
        'INWARD TEAM',
        'ASM',
        'Asm',
        'AREA_MANAGER',
        'Area Manager',
      ],
    },
  },
  {
    path: 'transfer-in/edit/:id',
    component: CreateTransferInComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        'STORE_MANAGER',
        'WAREHOUSE_MANAGER',
        'Admin',
        'MIS_TEAM',
        'INWARD_TEAM',
        'INWARD_TEAM',
        'INWARD TEAM',
        'ASM',
        'Asm',
        'AREA_MANAGER',
        'Area Manager',
      ],
    },
  },
  // {
  //   path: 'transfer-in/details/:id',
  //   component: CreateTransferInComponent,
  //   canActivate: [AuthGuard],
  //   data: { roles: ['STORE_MANAGER'] },
  // },
  {
    path: 'prn',
    component: PrnComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        'Admin',
        'STORE_MANAGER',
        'CATEGORY_MANAGER',
        'MIS_TEAM',
        'PRN_TEAM',
        'ASM',
        'Asm',
        'AREA_MANAGER',
        'Area Manager',
      ],
    },
  },
  {
    path: 'prn/create',
    component: CreatePrnComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      roles: [
        'Admin',
        'STORE_MANAGER',
        'CATEGORY_MANAGER',
        'PRN_TEAM',
        'ASM',
        'Asm',
        'AREA_MANAGER',
        'Area Manager',
      ],
    },
  },

  {
    path: 'prn/edit/:id',
    component: CreatePrnComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      roles: [
        'Admin',
        'STORE_MANAGER',
        'CATEGORY_MANAGER',
        'PRN_TEAM',
        'ASM',
        'Asm',
        'AREA_MANAGER',
        'Area Manager',
      ],
    },
  },
  {
    path: 'repack',
    component: RepackComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      roles: ['WAREHOUSE_MANAGER', 'Admin', 'CATEGORY_MANAGER', 'MIS_TEAM'],
    },
  },
  {
    path: 'repack/create-repack',
    component: AddRepackEntryComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      roles: ['WAREHOUSE_MANAGER', 'Admin', 'CATEGORY_MANAGER', 'MIS_TEAM'],
    },
  },
  {
    path: 'mbq/create-mbq',
    component: CreateMbqComponent,
    canActivate: [AuthGuard],
    data: { roles: ['Admin', 'CATEGORY_MANAGER', 'MIS_TEAM'] },
  },
  {
    path: 'mbq',
    component: MbqDraftListComponent,
    canDeactivate: [PendingChangesGuard],
    canActivate: [AuthGuard],
    data: { roles: ['Admin', 'CATEGORY_MANAGER'] },
  },
  {
    path: 'mbq/list',
    component: MbqDraftListComponent,
    canDeactivate: [PendingChangesGuard],
    canActivate: [AuthGuard],
    data: { roles: ['Admin', 'CATEGORY_MANAGER'] },
  },
  {
    path: 'mbq/upload',
    component: UploadMbqComponent,
    canDeactivate: [PendingChangesGuard],
    canActivate: [AuthGuard],
    data: { roles: ['Admin', 'CATEGORY_MANAGER'] },
  },
  {
    path: 'mbq/upload/:id',
    component: UploadMbqComponent,
    canDeactivate: [PendingChangesGuard],
    canActivate: [AuthGuard],
    data: { roles: ['Admin', 'CATEGORY_MANAGER'] },
  },
  {
    path: 'indent-list',
    component: IndentListComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['WAREHOUSE_MANAGER', 'Admin', 'CATEGORY_MANAGER', 'MIS_TEAM'],
    },
  },
  {
    path: 'indent-list/create-indent',
    component: CreateIndentComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['WAREHOUSE_MANAGER', 'Admin', 'CATEGORY_MANAGER', 'MIS_TEAM'],
    },
  },
  {
    path: 'indent-list/:id',
    component: ViewIndentListComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['WAREHOUSE_MANAGER', 'Admin', 'CATEGORY_MANAGER', 'MIS_TEAM'],
    },
  },

  {
    path: 'repack/edit/:id',
    component: AddRepackEntryComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['WAREHOUSE_MANAGER', 'Admin', 'CATEGORY_MANAGER'] },
  },
  {
    path: 'picklist/create',
    component: PickListComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin', 'WAREHOUSE_MANAGER'] },
  },
  {
    path: 'picklist/edit/:id/:grnId',
    component: PickListComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin', 'WAREHOUSE_MANAGER'] },
  },
  {
    path: 'picklist/:id',
    component: PickListComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin', 'WAREHOUSE_MANAGER'] },
  },
  {
    path: 'picklist',
    component: PicklistMasterComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin', 'WAREHOUSE_MANAGER'] },
  },
  {
    path: 'stocktake',
    component: StockTakeListComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin', 'STORE_MANAGER', 'MIS_TEAM', 'LP_TEAM'] },
  },
  {
    path: 'stocktake/create',
    component: StockTakeCreateComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin', 'STORE_MANAGER', 'MIS_TEAM', 'LP_TEAM'] },
  },
  {
    path: 'stocktake/edit/:id',
    component: StockTakeCreateComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin', 'STORE_MANAGER', 'MIS_TEAM', 'LP_TEAM'] },
  },
  {
    path: 'stocktake/session/:id',
    component: StockTakeDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: ['Admin', 'STORE_MANAGER', 'MIS_TEAM', 'LP_TEAM'] },
  },
  {
    path: 'gst-slab',
    component: GstSlabViewComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin'] },
  },
  {
    path: 'gst-slab/create',
    component: GstSlabCreateComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin'] },
  },
  {
    path: 'gst-slab/edit/:id',
    component: GstSlabCreateComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin'] },
  },
  {
    path: 'services',
    component: ServiceListComponent,
    canActivate: [AuthGuard, ClinicOnlyGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin', 'STORE_MANAGER'] },
  },
  {
    path: 'services/edit/:id',
    component: CreateServiceComponent,
    canActivate: [AuthGuard, ClinicOnlyGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin', 'STORE_MANAGER'] },
  },
  {
    path: 'services/create',
    component: CreateServiceComponent,
    canActivate: [AuthGuard, ClinicOnlyGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin', 'STORE_MANAGER'] },
  },

  {
    path: 'services-billing',
    component: ServiceBillingComponent,
    canActivate: [AuthGuard, ClinicOnlyGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin', 'STORE_MANAGER', 'Cashier', 'CASHIER'] },
  },
  {
    path: 'stock-movement',
    component: StockMovementComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin', 'MIS_TEAM', 'STORE_MANAGER'] },
  },
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin', 'STORE_MANAGER'] },
  },
  {
    path: 'detailed-report',
    component: DetailedReportComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin', 'STORE_MANAGER'] },
  },
  {
    path: 'stock-write-off',
    component: StockWriteOffListComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin', 'STORE_MANAGER'] },
  },
  {
    path: 'stock-write-off/create',
    component: CreateStockWriteOffComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['Admin', 'STORE_MANAGER'] },
  },
  {
    path: 'terminals',
    component: TerminalsComponent,
    canActivate: [AuthGuard],
    data: { roles: ['Admin', 'STORE_MANAGER', 'AREA_MANAGER', 'ASM'] },
  },
  {
    path: 'roles-access',
    component: RolesAccessComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      roles: ['Admin', 'SUPER_ADMIN'],
      pageKey: 'controlpanel.roles-access',
    },
  },
  {
    path: 'configuration',
    loadComponent: () =>
      import('./features/configuration/configuration.component').then(
        (m) => m.ConfigurationComponent
      ),
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      roles: ['Admin', 'SUPER_ADMIN'],
      pageKey: 'controlpanel.configuration',
    },
  },
  {
    path: 'reason-master',
    loadComponent: () =>
      import('./features/reason-master/reason-master.component').then(
        (m) => m.ReasonMasterComponent
      ),
    canActivate: [AuthGuard],
    data: {
      roles: ['Admin', 'SUPER_ADMIN'],
      pageKey: 'controlpanel.reason-master',
    },
  },
  {
    path: 'kit-master',
    loadComponent: () =>
      import('./features/kit-master/kit-master.component').then(
        (m) => m.KitMasterComponent
      ),
    canActivate: [AuthGuard],
    data: {
      roles: ['Admin', 'SUPER_ADMIN', 'WAREHOUSE_MANAGER', 'CATEGORY_MANAGER', 'MIS_TEAM'],
      pageKey: 'stock.kit-master',
    },
  },
  {
    path: 'kit-preparation',
    loadComponent: () =>
      import('./features/kit-preparation/kit-preparation.component').then(
        (m) => m.KitPreparationComponent
      ),
    canActivate: [AuthGuard],
    data: {
      roles: ['Admin', 'SUPER_ADMIN', 'WAREHOUSE_MANAGER', 'CATEGORY_MANAGER', 'MIS_TEAM'],
      pageKey: 'stock.kit-preparation',
    },
  },
  // ── B2B Sales (gated by the b2b.enabled configuration switch) ──────────
  { path: 'b2b-orders', redirectTo: 'b2b-orders/dashboard', pathMatch: 'full' },
  {
    path: 'b2b-orders/dashboard',
    loadComponent: () =>
      import('./features/b2b/orders/b2b-orders.component').then(
        (m) => m.B2BOrdersComponent
      ),
    canActivate: [AuthGuard, b2bEnabledGuard],
    data: {
      roles: ['Admin', 'SUPER_ADMIN', 'STORE_MANAGER', 'MIS_TEAM'],
      pageKey: 'b2b.orders',
    },
  },
  {
    path: 'b2b-orders/create',
    loadComponent: () =>
      import('./features/b2b/orders/create-b2b-order/create-b2b-order.component').then(
        (m) => m.CreateB2BOrderComponent
      ),
    canActivate: [AuthGuard, b2bEnabledGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      roles: ['Admin', 'SUPER_ADMIN', 'STORE_MANAGER', 'MIS_TEAM'],
      pageKey: 'b2b.orders',
      requiresFull: true,
    },
  },
  {
    path: 'b2b-orders/edit/:id',
    loadComponent: () =>
      import('./features/b2b/orders/create-b2b-order/create-b2b-order.component').then(
        (m) => m.CreateB2BOrderComponent
      ),
    canActivate: [AuthGuard, b2bEnabledGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      roles: ['Admin', 'SUPER_ADMIN', 'STORE_MANAGER', 'MIS_TEAM'],
      pageKey: 'b2b.orders',
      requiresFull: true,
    },
  },
  {
    path: 'b2b-customer',
    loadComponent: () =>
      import('./features/b2b/customers/b2b-customers.component').then(
        (m) => m.B2BCustomersComponent
      ),
    canActivate: [AuthGuard, b2bEnabledGuard],
    data: {
      roles: ['Admin', 'SUPER_ADMIN', 'STORE_MANAGER', 'MIS_TEAM'],
      pageKey: 'b2b.customers',
    },
  },
  {
    path: 'add-b2b-customer',
    loadComponent: () =>
      import('./features/b2b/customers/b2b-customer-form/b2b-customer-form.component').then(
        (m) => m.B2BCustomerFormComponent
      ),
    canActivate: [AuthGuard, b2bEnabledGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      roles: ['Admin', 'SUPER_ADMIN', 'STORE_MANAGER', 'MIS_TEAM'],
      pageKey: 'b2b.customers',
      requiresFull: true,
    },
  },
  {
    path: 'edit-b2b-customer/:id',
    loadComponent: () =>
      import('./features/b2b/customers/b2b-customer-form/b2b-customer-form.component').then(
        (m) => m.B2BCustomerFormComponent
      ),
    canActivate: [AuthGuard, b2bEnabledGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      roles: ['Admin', 'SUPER_ADMIN', 'STORE_MANAGER', 'MIS_TEAM'],
      pageKey: 'b2b.customers',
      requiresFull: true,
    },
  },
  // ── Super Admin (platform operator) ─────────────────────────────────────
  // `superAdminOnly` is enforced by AuthGuard: tenant Admins never see these.
  {
    path: 'super-admin/clients',
    loadComponent: () =>
      import('./features/super-admin/clients-list/clients-list.component').then(
        (m) => m.SuperAdminClientsListComponent
      ),
    canActivate: [AuthGuard],
    data: { roles: ['SUPER_ADMIN'], superAdminOnly: true },
  },
  {
    path: 'super-admin/onboard',
    loadComponent: () =>
      import('./features/super-admin/onboarding-wizard/onboarding-wizard.component').then(
        (m) => m.OnboardingWizardComponent
      ),
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard],
    data: { roles: ['SUPER_ADMIN'], superAdminOnly: true },
  },
  {
    path: 'super-admin/wallet-pricing',
    loadComponent: () =>
      import('./features/super-admin/wallet-pricing/wallet-pricing.component').then(
        (m) => m.WalletPricingComponent
      ),
    canActivate: [AuthGuard],
    data: { roles: ['SUPER_ADMIN'], superAdminOnly: true },
  },
  {
    path: 'super-admin/usage',
    loadComponent: () =>
      import('./features/super-admin/usage-analytics/usage-analytics.component').then(
        (m) => m.UsageAnalyticsComponent
      ),
    canActivate: [AuthGuard],
    data: { roles: ['SUPER_ADMIN'], superAdminOnly: true },
  },
  {
    path: 'super-admin/industry-templates',
    loadComponent: () =>
      import('./features/super-admin/industry-templates/industry-templates.component').then(
        (m) => m.IndustryTemplatesComponent
      ),
    canActivate: [AuthGuard],
    data: { roles: ['SUPER_ADMIN'], superAdminOnly: true },
  },
  // Workspace wallet: balance, prices and history for the signed-in client.
  {
    path: 'wallet',
    loadComponent: () =>
      import('./features/wallet/wallet.component').then((m) => m.WalletComponent),
    canActivate: [AuthGuard],
    data: { roles: ['Admin', 'SUPER_ADMIN'] },
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
  // Detour used by FormReloadService to rebuild a create form after a save.
  // Reached only with skipLocationChange, so it never appears in the URL.
  { path: FORM_RELOAD_PATH, component: FormReloadBlankComponent },
  { path: '', component: HomeComponent },
  // AuthGuard and the error interceptor redirect to /login; the login screen
  // lives at ''. 'home' likewise only existed as a wildcard target.
  { path: 'login', redirectTo: '' },
  { path: 'home', redirectTo: '' },
  { path: '**', redirectTo: '' },
];
